// 发现
export default [
  // 内容主页
  {
    path: '/discoverHome',
    name: 'DiscoverHome',
    meta: {
      IndexHeader: true,
      itemIndex: 2
    },
    component: () =>
      import(/* webpackChunkName: "DiscoverHome" */ '@/components/discover/home/index.vue')
  },
  {
    path: '/search',
    name: 'Search',
    meta: {
      IndexHeader: true,
      itemIndex: 2
    },
    component: () =>
      import(/* webpackChunkName: "DiscoverHome" */ '@/components/search/index.vue')
  },
  {
    path: '/searchReault',
    name: 'searchReault',
    meta: {
      IndexHeader: true,
      itemIndex: 2
    },
    component: () =>
      import(/* webpackChunkName: "DiscoverHome" */ '@/components/search/searchReault.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/discover.js